import React, { useState } from "react";
import { connect } from "react-redux";
import { CurrentStepSetAction } from "./../../../actions/action";
import CONSTANTS from "../../../constants";
import chevronOrange from "../../../images/AC/ac_chevron_down_orange.png";
import locationIconBlue from "../../../images/AC/ac-location-summary-blue.png";
import calendarIcon from "../../../images/AC/ac-calendar-summary.png";
import clockIcon from "../../../images/AC/ac-clock-summary.png";
import editIcon from "../../../images/AC/ac-edit-summary.png";
import rightArrow from "../../../images/AC/ac-chevron-right-small-orange.png";
import { pushEventToGTM } from "../../../helpers/trackerManager";
import { Link } from "react-router-dom";
import alertIcon from "../../../images/AC/ac-alert-white.png";
import editIconBlack from "../../../images/AC/ac-edit-summary-black.png";
import { slugify } from "../../../helpers/functions";

const mapStateToProps = (state) => state;
const mapDispatchToProps = { CurrentStepSetAction };

const DealerSummaryFlex = (props) => {
  const [showNextEditButtonDealer, setShowNextEditButtonDealer] = useState(
    false
  );
  const [showNextEditButtonDate, setShowNextEditButtonDate] = useState(false);
  const [isOpen, setIsOpen] = useState(true);
  const { dealer, booking, isEditMode } = props.store;
  const iconLink =
    "https://rendezvousenligne.citroen.fr/v2-assets/static/media/pin-ac-hover.svg";

  return (
    <div className="rootDealerContainer">
      <div className="dealerSectionTitleContainer">
        <div className="dealerSectionTitle">
          {CONSTANTS.LABELS.summary_appointment}
        </div>
        <img
          src={chevronOrange}
          className={isOpen ? "chevronDetail isOpen" : "chevronDetail"}
          onClick={() => setIsOpen(!isOpen)}
        />
      </div>
      <div
        className={
          isOpen ? "dealerContentContainer isOpen" : "dealerContentContainer"
        }
      >
        <div className="dealerName">{dealer.name}</div>
        <div className="dealerBodyContainer">
          <div className="separatorDealer"></div>
          <div className="dealerInfosMapContainer">
            <div className="dealerInfosContainer">
              <div className="sectionContainer">
                <div className="sectionTitleIconContainer">
                  <img src={locationIconBlue} />
                  <div className="sectionTitle">
                    {CONSTANTS.LABELS.summary_appointment_address}
                  </div>
                </div>
                <div className="dealerAddress">
                  {dealer
                    ? `${dealer.adress} \n ${dealer.zip} ${dealer.city}`
                    : undefined}
                </div>

                {!showNextEditButtonDealer && props.isWithPrice && !isEditMode && (
                  <div
                    className="editButton"
                    onClick={(e) => {
                      pushEventToGTM({
                        pageName: "summary",
                        eventAction: "Redirection::Internal::Modify",
                        eventLabel: "summary_modify_dealer",
                      });
                      setShowNextEditButtonDealer(true);
                    }}
                  >
                    <img src={editIcon} />
                    <div className="editButtonTitle">
                      {CONSTANTS.LABELS.common_v2_modify}
                    </div>
                  </div>
                )}

                {!showNextEditButtonDealer &&
                  !props.isWithPrice &&
                  !isEditMode && (
                    <Link
                      to={CONSTANTS.SITE_ROUTS.HOMEPAGE}
                      onClick={() => {
                        pushEventToGTM({
                          pageName: "summary",
                          eventAction: "Redirection::Internal::Modify",
                          eventLabel: "summary_modify_dealer",
                        });
                      }}
                    >
                      <div className="editButton">
                        <img src={editIcon} />
                        <div className="editButtonTitle">
                          {CONSTANTS.LABELS.common_v2_modify}
                        </div>
                      </div>
                    </Link>
                  )}

                {showNextEditButtonDealer && (
                  <div className="linkAlertContainer">
                    <Link
                      className="linkConfirmation"
                      to={CONSTANTS.SITE_ROUTS.HOMEPAGE}
                    >
                      <div className="editButton">
                        <img src={editIconBlack} />
                        <div className="editButtonTitle isConfirm">
                          {CONSTANTS.LABELS.summary_warning1_continue}
                        </div>
                      </div>
                    </Link>

                    {/* Popin for confirmation of edit dealer*/}
                    {props.isWithPrice && (
                      <div className="popinConfirm">
                        <img src={alertIcon} />
                        {CONSTANTS.LABELS.summary_warning_alert_dealer}
                      </div>
                    )}
                  </div>
                )}
              </div>

              <div className="dateHourContainer">
                <div className="sectionContainer">
                  <div className="sectionTitleIconContainer">
                    <img src={calendarIcon} />
                    <div className="sectionTitle">
                      {CONSTANTS.LABELS.summary_appointment_date}
                    </div>
                  </div>
                  <div className="dealerAddress">{booking.date}</div>
                </div>

                <div className="sectionContainer">
                  <div className="sectionTitleIconContainer">
                    <img src={clockIcon} />
                    <div className="sectionTitle">
                      {CONSTANTS.LABELS.summary_appointment_hour}
                    </div>
                  </div>
                  <div className="dealerAddress">{booking.hour}</div>
                </div>
              </div>

              {/* Start Edit button (change Date) */}
              {((!showNextEditButtonDate && props.isWithPrice && !isEditMode) ||
                (!showNextEditButtonDate &&
                  props.isWithPrice &&
                  isEditMode &&
                  !props.expiredDate)) && (
                <div
                  className="editButton"
                  onClick={(e) => {
                    pushEventToGTM({
                      pageName: "summary",
                      eventAction: "Redirection::Internal::Modify",
                      eventLabel: "summary_modify_timeslot",
                    });
                    setShowNextEditButtonDate(true);
                  }}
                >
                  <img src={editIcon} />
                  <div className="editButtonTitle">
                    {CONSTANTS.LABELS.common_v2_modify}
                  </div>
                </div>
              )}

              {((!showNextEditButtonDate &&
                !props.isWithPrice &&
                dealer.city &&
                !isEditMode) ||
                (!showNextEditButtonDate &&
                  !props.isWithPrice &&
                  dealer.city &&
                  isEditMode &&
                  !props.expiredDate)) && (
                <Link
                  to={`${CONSTANTS.SITE_ROUTS.SOLODEALERPAGE}${slugify(
                    dealer.city
                  ) +
                    "/" +
                    slugify(dealer.name) +
                    "/" +
                    dealer.geoID}`}
                  onClick={(e) => {
                    pushEventToGTM({
                      pageName: "summary",
                      eventAction: "Redirection::Internal::Modify",
                      eventLabel: "summary_modify_timeslot",
                    });
                  }}
                >
                  <div className="editButton">
                    <img src={editIcon} />
                    <div className="editButtonTitle">
                      {CONSTANTS.LABELS.common_v2_modify}
                    </div>
                  </div>
                </Link>
              )}

              {showNextEditButtonDate && (
                <div className="linkAlertContainer">
                  <Link
                    className="linkConfirmation"
                    to={`${CONSTANTS.SITE_ROUTS.SOLODEALERPAGE}${slugify(
                      dealer.city
                    ) +
                      "/" +
                      slugify(dealer.name) +
                      "/" +
                      dealer.geoID}`}
                  >
                    <div className="editButton">
                      <img src={editIconBlack} />
                      <div className="editButtonTitle isConfirm">
                        {CONSTANTS.LABELS.summary_warning1_continue}
                      </div>
                    </div>
                  </Link>

                  {/* Popin for confirmation of edit dealer*/}
                  {props.isWithPrice && (
                    <div className="popinConfirm">
                      <img src={alertIcon} />
                      {CONSTANTS.LABELS.summary_warning_alert_slot}
                    </div>
                  )}
                </div>
              )}

              {/* End Edit button (change Date) */}
            </div>
            {window.isMobile() === "desktop" && dealer.position && (
              <div className="dealerMapContainer">
                <img
                  src={`https://maps.googleapis.com/maps/api/staticmap?zoom=13&size=${
                    window.innerWidth < 800 ? window.innerWidth - 60 : 300
                  }x${170}&maptype=roadmap&markers=icon:${iconLink}|${
                    dealer.position.lat
                  },${dealer.position.lng}&key=${
                    CONSTANTS.SITE_INFO.GOOGLE_MAP_API_KEY
                  }`}
                />
                <div className="itineraryButton">
                  <a
                    className="itineraryButtonTitle"
                    rel="noopener noreferrer"
                    href={`https://www.google.com/maps/dir//${dealer.position.lat},${dealer.position.lng}/@${dealer.position.lat},${dealer.position.lng},13z`}
                    target="_blank"
                    onClick={() => {
                      pushEventToGTM({
                        pageName: "summary",
                        eventAction: "Redirection::External::Map",
                        eventLabel:
                          CONSTANTS.LABELS.summary_appointment_togooglemap,
                      });
                    }}
                  >
                    {CONSTANTS.LABELS.summary_appointment_togooglemap}
                  </a>
                  <img src={rightArrow} />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(DealerSummaryFlex);
